import { useEffect, useState } from 'react';

import { CreditCard, Shield } from 'lucide-react';

export default function ViewMonEspace() {
  const [payVisible, setPayVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setPayVisible(true), 1100);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className='demo-view-enter space-y-8'>
      <div className='grid grid-cols-2 md:grid-cols-4 gap-4'>
        {[
          { v: '5', l: 'inscriptions', c: 'text-blue-600 dark:text-blue-400' },
          { v: '3', l: 'confirmées', c: 'text-emerald-600 dark:text-emerald-400' },
          { v: '1', l: 'en attente', c: 'text-amber-600 dark:text-amber-400' },
          { v: '47', l: 'concours joués', c: 'text-purple-600 dark:text-purple-400' },
        ].map(({ v, l, c }) => (
          <div
            key={l}
            className='bg-slate-50 border border-slate-200 dark:bg-slate-900 dark:border-slate-800 rounded-2xl p-5 text-center'
          >
            <p className={`text-2xl font-black ${c}`}>{v}</p>
            <p className='text-[11px] text-slate-500 mt-1'>{l}</p>
          </div>
        ))}
      </div>

      <div className='grid md:grid-cols-2 gap-6'>
        {/* Inscriptions récentes */}
        <div>
          <p className='text-[10px] font-black text-slate-500 uppercase tracking-widest mb-4'>Mes inscriptions</p>
          <div className='space-y-3'>
            {/* Confirmée + payée */}
            <div className='bg-emerald-50/60 border border-emerald-200/60 dark:bg-slate-800/60 dark:border-emerald-500/30 rounded-2xl p-4'>
              <div className='flex items-start justify-between gap-2 mb-2'>
                <div className='flex-1 min-w-0'>
                  <p className='font-bold text-slate-900 dark:text-white text-sm truncate'>Grand Prix Gerland</p>
                  <p className='text-xs text-slate-500 dark:text-slate-400 mt-0.5'>
                    Doublette · Lyon, 69 · 13 Jun 2026
                  </p>
                </div>
                <span className='shrink-0 bg-emerald-500/10 border border-emerald-500/20 text-emerald-600 dark:text-emerald-400 text-[9px] font-black px-2 py-0.5 rounded-md uppercase'>
                  Confirmé
                </span>
              </div>
              <div className='flex items-center justify-between text-xs text-slate-500 dark:text-slate-400'>
                <span className='flex items-center gap-1.5'>
                  <CreditCard className='w-3 h-3' />
                  30 € — paiement OK
                </span>
                <span>Dubois / Bernard</span>
              </div>
            </div>

            {/* En attente de paiement */}
            <div
              className={`border rounded-2xl p-4 transition-all duration-700 ${
                payVisible
                  ? 'bg-amber-50/60 border-amber-200/60 dark:bg-slate-800/60 dark:border-amber-500/30'
                  : 'bg-slate-50 border-slate-200 dark:bg-slate-800/40 dark:border-slate-700'
              }`}
            >
              <div className='flex items-start justify-between gap-2 mb-2'>
                <div className='flex-1 min-w-0'>
                  <p className='font-bold text-slate-900 dark:text-white text-sm truncate'>Open Été Bordeaux</p>
                  <p className='text-xs text-slate-500 dark:text-slate-400 mt-0.5'>
                    Doublette · Bordeaux, 33 · 5 Jul 2026
                  </p>
                </div>
                <span
                  className={`shrink-0 text-[9px] font-black px-2 py-0.5 rounded-md uppercase transition-all ${
                    payVisible
                      ? 'bg-amber-500/10 border border-amber-500/20 text-amber-600 dark:text-amber-400'
                      : 'bg-slate-100 border border-slate-200 text-slate-400 dark:bg-slate-800 dark:border-slate-700'
                  }`}
                >
                  {payVisible ? 'Payer' : 'En attente'}
                </span>
              </div>
              <div className='flex items-center justify-between text-xs text-slate-500 dark:text-slate-400'>
                <span className='flex items-center gap-1.5'>
                  <CreditCard className='w-3 h-3' />
                  {payVisible ? '25 € — paiement en attente' : '25 € — en cours…'}
                </span>
              </div>
            </div>

            <p className='text-center text-slate-500 dark:text-slate-600 text-xs pt-1'>+ 3 autres inscriptions</p>
          </div>
        </div>

        {/* Profil FFPJP */}
        <div>
          <p className='text-[10px] font-black text-slate-500 uppercase tracking-widest mb-4'>Mon profil fédéral</p>
          <div className='bg-slate-50 border border-slate-200 dark:bg-slate-900 dark:border-slate-800 rounded-2xl p-5 space-y-4'>
            <div className='flex items-center gap-3'>
              <div className='w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center font-black text-white shadow-lg shadow-blue-600/30 dark:shadow-blue-900/40 shrink-0'>
                PD
              </div>
              <div>
                <p className='font-bold text-slate-900 dark:text-white'>Pierre Dubois</p>
                <p className='text-xs text-slate-500 dark:text-slate-400'>Licence FFPJP #06900123</p>
              </div>
            </div>

            <div className='grid grid-cols-2 gap-3'>
              {[
                { label: 'Catégorie', value: 'Senior' },
                { label: 'Classification', value: 'Confirmé' },
                { label: 'Concours joués', value: '47' },
                { label: 'Podiums', value: '23' },
              ].map(({ label, value }) => (
                <div
                  key={label}
                  className='bg-white border border-slate-200 dark:bg-slate-800/60 dark:border-slate-700 rounded-xl p-3'
                >
                  <p className='text-[10px] font-black text-slate-500 uppercase tracking-widest mb-1'>{label}</p>
                  <p className='font-bold text-slate-900 dark:text-white text-sm'>{value}</p>
                </div>
              ))}
            </div>
          </div>

          <div className='mt-3 flex items-start gap-2 text-xs text-slate-500 bg-slate-50 border border-slate-200 dark:bg-slate-900/50 dark:border-slate-800 rounded-xl px-4 py-3'>
            <Shield className='w-3.5 h-3.5 shrink-0 mt-0.5' />
            <span>Données fédérales FFPJP associées à votre compte. Catégorie calculée automatiquement.</span>
          </div>
        </div>
      </div>
    </div>
  );
}
